export interface BreedItem {
  name: string;
  slug: string;
}

export interface CreateBreedsSchemaArgs {
  breeds: BreedItem[];
  baseUrl: string;
}

export function createBreedsSchema({
  breeds,
  baseUrl,
}: CreateBreedsSchemaArgs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    '@id': `${baseUrl}/breed#webpage`,
    name: "Fresh Dog Food for Every Breed | The Farmer's Dog",
    url: `${baseUrl}/breed`,
    description:
      'Fresh, human-grade dog food plans for every breed. Find breed-specific nutrition tips and build a personalized plan for your dog.',
    publisher: {
      '@id': `${baseUrl}/#organization`,
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: baseUrl,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Breeds',
          item: `${baseUrl}/breed`,
        },
      ],
    },
    mainEntity: {
      '@type': 'ItemList',
      name: 'All Dog Breeds',
      itemListElement: breeds.map(({ name, slug }, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name,
        url: `${baseUrl}/breed/${slug}`,
      })),
    },
  };
}
